import React from "react";
import { Tooltip } from "@mui/material";

interface SubmitButtonWithTooltipProps {
  isValid: boolean;
  missingLabels: string[];
  isSubmitting?: boolean;
  disabled?: boolean;
  disabledReason?: string;
  submitLabel?: string;
  submittingLabel?: string;
  formId?: string;
  className?: string;
}

const SubmitButtonWithTooltip: React.FC<SubmitButtonWithTooltipProps> = ({
  isValid,
  missingLabels,
  isSubmitting = false,
  disabled = false,
  disabledReason,
  submitLabel = "Save",
  submittingLabel = "Saving...",
  formId,
  className = "btn btn-primary",
}) => {
  const blocked = !isValid || disabled;
  const isButtonDisabled = blocked || isSubmitting;

  const tooltipTitle = !isValid && missingLabels.length > 0
    ? `Please fill all required fields: ${missingLabels.join(", ")}`
    : disabled && disabledReason
    ? disabledReason
    : "";

  const handleClickCapture = (e: React.MouseEvent) => {
    if (!blocked) return;
    e.preventDefault();
    const scope: Document | HTMLElement = formId
      ? document.getElementById(formId) || document
      : document;
    const invalidEl = scope.querySelector(".is-invalid");
    if (invalidEl) {
      invalidEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <Tooltip title={tooltipTitle}>
      <span
        onClickCapture={handleClickCapture}
        style={{ display: "inline-block" }}
      >
        <button
          type="submit"
          className={className}
          disabled={isButtonDisabled}
          style={
            disabled && !isSubmitting ? { pointerEvents: "none" } : undefined
          }
        >
          {isSubmitting ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
              {submittingLabel}
            </>
          ) : (
            submitLabel
          )}
        </button>
      </span>
    </Tooltip>
  );
};

export default SubmitButtonWithTooltip;
